// extracted by mini-css-extract-plugin
export default {"titlewithicon":"InfoChip_titlewithicon__cDugp"};